import type { ModalData } from '@presentation/components/Modal';

export interface MtBreederStorePartnershipModalData {
  modal: ModalData;
  onConfirm(): void;
}

export interface MtBreederStorePartnershipModalProps extends MtBreederStorePartnershipModalData {}
